import { createSlice } from "@reduxjs/toolkit";

const propertyJourneyStatusSlice = createSlice({
  name: "propertyJourneyStatus",
  initialState: {},
  reducers: {
    addPropertyJourneyStatus: (state: any, action: any): any => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { addPropertyJourneyStatus } = propertyJourneyStatusSlice.actions;

export default propertyJourneyStatusSlice.reducer;
